
export default function employeeedit( state = [], action = {} ){

	switch( action.type ){
		case 'GET_EMPLOYEE_EDIT':
			return action.employeeedit
		case 'GET_DEPARTMENT_EDIT':
			return action.employeeedit
		case 'GET_EMPLOYEE_LIST_EDIT':
			return action.employeeedit
		case 'GET_DESIGNATION_EDIT':
			return action.employeeedit
		case 'GET_COMPANY_EDIT':
			return action.employeeedit
		case 'UPDATE_EMPLOYEE_EDIT':
			return action.employeeedit
		case 'UPLOADED_PROFILE_PIC':
			return action.employeeedit
		case 'UPLOADED_DOCUMENT':
			return action.employeeedit
		case 'DELETE_DOCUMENT':
			return action.employeeedit
		case 'GET_EMPLOYEE_ASSETS':
			return action.employeeedit
		case 'SAVE_ASSET_LOG':
			return action.employeeedit
		case 'DELETE_ASSET_LOG':
			return action.employeeedit
		case 'SET_RT_DATE_ASSET_LOG':
			return action.employeeedit
		case 'SET_GN_DATE_ASSET_LOG':
			return action.employeeedit
		case 'SET_LOG_NOTES':
			return action.employeeedit
		default: return state;
	}
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/employee.edit/employee.edit.reducer.js